import script from "./BizSlider.vue?vue&type=script&lang=ts"
export * from "./BizSlider.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__